import { Component } from "@angular/core";

@Component({
  selector: "toolbox-menus",
  templateUrl: "./menus.component.html",
  styleUrls: ["./menus.component.scss"],
})
export class MenusComponent {}
